import { render } from "./otp.vue?vue&type=template&id=30e20d48"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"
script.render = render

export default script